// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/element-ui/lib/theme-chalk/slider.css
// module id = BxWU
// module chunks = 9